import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import NewImgBannerIMG from "../images/newimg/banner.jpg";
import AboutUs from "../images/banner3.png";
import Gradient1IMG from "../images/newimg/gradient1.jpg";
import Gradient2IMG from "../images/newimg/gradenthow.jpg";
import icon2 from "../images/icon2.svg";
import icon3 from "../images/icon3.svg";
import icon4 from "../images/icon4.svg";
import icon5 from "../images/icon5.svg";
import icon6 from "../images/icon6.svg";
import icon7 from "../images/icon7.svg";
import icon8 from "../images/icon8.svg";
import icon9 from "../images/icon9.svg";
import icon10 from "../images/icon10.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import Therapy from "../images/newimg/therapynew.png";
import TherapyNew from "../images/therapynew1.png";
import Contact from "../inc/Form";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import { Tooltip } from "react-tooltip";
import ConstConfig from "../../utility/configs/constConfig";
import ImageConfig from "../../utility/configs/imageConfig";
import StarRatings from "react-star-ratings";
import AOS from "aos";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import UserAvatar from "../common/UserAvatar";
import Hicon1 from "../images/newimg/hicon1.svg";
import Work1 from "../images/newimg/works1.png";
import Work2 from "../images/newimg/works2.png";
import Wicon1 from "../images/newimg/wicon1.svg";
import Wicon2 from "../images/newimg/wicon2.svg";
import Wicon3 from "../images/newimg/wicon3.svg";
import Wicon4 from "../images/newimg/wicon4.svg";
import Wicon5 from "../images/newimg/wicon5.svg";
import Wicon6 from "../images/newimg/wicon6.svg";
import AppleIcon from "../images/newimg/apple.svg";
import PlayStoreIcon from "../images/newimg/playstore.svg";
import StepIMG1 from "../images/newimg/step.jpg";
import StepIMG2 from "../images/browse_and_filter_therapist.png";
import StepIMG3 from "../images/choose_and_book2.png";
import StepIMG4 from "../images/secure_payments.png";
import StepIMG5 from "../images/get_ready_for_session2.png";
import ContactIMG from "../images/newimg/contact.png";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  Button,
  Col,
  Image,
  Nav,
  ProgressBar,
  Row,
  Tab,
} from "react-bootstrap";
import FavLoader from "../common/FavLoader";
import HomeSlider from "../commoncomponent/HomeSlider";
import { trackScreenView, trackButtonClick, trackEvent, getUserTrackingParams } from "../../utility/services/analyticsService";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4.2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3.6,
  },
  tablet: {
    breakpoint: { max: 1024, min: 767 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1.3,
  },
};

const Home = () => {
  // LOGICAL VARIABLES
  useEffect(() => {
    AOS.init({
      disable: true,
      once: true,
    });
    return () => AOS.refresh();
  }, []);

  const { setAuthRole, footer_ref, user, banner_details, setBannerDetails } =
    useContext(AuthContext);

  const { enctyptDataFun, consoleService } = Functions();
  const {
    get_popular_therapist_public,
    get_popular_therapist,
    add_to_favorite,
    get_dashboard_banner_details_and_list,
  } = ApiService();

  const userDetails = user.details ? user.details : null;
  const isUserDetails = userDetails != null;
  const userRole = isUserDetails ? userDetails.role : null;
  const isRoleTherapist = userRole == "Therapist";
  const isRolePatient = userRole == "Patient";

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("step1");
  const [progress, setProgress] = useState(0);

  // DATA VARIABLES

  const [therapistList, setTherapistList] = useState([]);
  const [selected_tile, setSelectetTile] = useState("first");
  const [selected_card, setSeletcedCard] = useState(null);
  const [fav_loading, setFavLoading] = useState(false);
  const isLinkForPatient = selected_tile == "first";
  const steps = ["step1", "step2", "step3", "step4", "step5"];

  const steps_index_ref = useRef(0);
  const hoveredRef = useRef(false);
  const intervalRef = useRef(null);

  const ios_app_link = isLinkForPatient
    ? "https://apps.apple.com/in/app/ecare-therapy/id6477286804"
    : "https://apps.apple.com/in/app/ecare-for-therapists/id6477288287";
  const android_app_link = isLinkForPatient
    ? "https://play.google.com/store/apps/details?id=com.ecaretherapy.app"
    : "https://play.google.com/store/apps/details?id=com.ecaretherapist.app";

  const startInterval = () => {
    if (intervalRef.current) clearInterval(intervalRef.current); // Clear existing interval
    intervalRef.current = setInterval(() => {
      if (!hoveredRef.current) {
        // Only change if not hovered
        const next_index = (steps_index_ref.current + 1) % steps.length;
        steps_index_ref.current = next_index;
        setActiveTab(steps[next_index]);

        // Calculate progress
        const progressValue = ((next_index + 1) / steps.length) * 100;
        setProgress(progressValue);
      }
    }, 10000);
  };

  // USE EFFECT

  useEffect(() => {
    trackScreenView("onboarding_screen", { screen_name: "Home", ...getUserTrackingParams(user) });
    fetch_initialData_fun();
  }, []);

  useEffect(() => {
    startInterval();
    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);

  // FUNCTIONS

  async function fetch_initialData_fun() {
    try {
      const res = isUserDetails
        ? await get_popular_therapist()
        : await get_popular_therapist_public();
      if (res.status === 1) {
        setTherapistList([...res.data]);
        const banner_res = await get_dashboard_banner_details_and_list();
        if (banner_res.status === 1) {
          setBannerDetails(banner_res.data);
        }
      } else {
        consoleService("error ininitialData Fun = ", res.message);
      }
    } catch (err) {
      consoleService("error ininitialData Fun = ", err);
    }
  }

  const set_login_role = () => {
    setAuthRole("Patient");
    localStorage.setItem("E_C_R_O_L_E", enctyptDataFun("Patient"));
  };

  const handleScrollToBottom = (e) => {
    e.preventDefault();
    footer_ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleMouseEnter = (tab) => {
    hoveredRef.current = true;
    setActiveTab(tab);
    clearInterval(intervalRef.current);
    const find_current_index = steps.findIndex((item) => item == tab);
    const steps_length = steps.length;

    const next_index = find_current_index % steps_length;
    const progressValue = ((next_index + 1) / steps_length) * 100;
    setProgress(progressValue);
    steps_index_ref.current = next_index;
  };

  const handleMouseLeave = () => {
    hoveredRef.current = false;
    startInterval();
  };

  const add_to_favorite_fun = async (therapist_id, status) => {
    try {
      setSeletcedCard(therapist_id);
      setFavLoading(true);
      const data = {
        therapist_id,
        status: !status,
      };
      const res = await add_to_favorite(data);

      if (res.status === 1) {
        const newTherapistList = therapistList.map((item) => {
          if (item._id == therapist_id) {
            const orgItem = item;
            orgItem.isFavorite = res.data.status;
            return orgItem;
          } else {
            return item;
          }
        });
        setTherapistList([...newTherapistList]);
        setSeletcedCard(null);
        setFavLoading(false);
      }
    } catch (err) {
      consoleService("error in add t favorite fun = ", err);
    }
  };

  return (
    <>
      <HomeSlider data={{ set_login_role, isUserDetails, banner_details }} />

      <section
        id="about"
        className="aboutUs aboutUs1"
        style={{ backgroundImage: `url(${Gradient1IMG})` }}
      >
        <div className="container">
          <div className="row ">
            <div className="col-md-12">
              <div className="aboutUsPadding">
                <div className="row align-items-center">
                  <div
                    className="col-md-6 "
                    data-aos="fade-left"
                    data-aos-duration="1000"
                    data-aos-delay="50"
                  >
                    <h3>What Is eCare Therapy?</h3>
                    <h2>
                      <span>Therapy on</span> your terms
                    </h2>
                    <p>
                      At eCare Therapy, we’re redefining therapy by making
                      online sessions with licensed professionals simple,
                      accessible, and welcoming for everyone. 
                    </p>
                    <p>
                      Browse, filter, choose, and connect—no subscriptions, no
                      commitment, just personalized mental health support at
                      your fingertips.
                    </p>
                    <br />
                    <Link
                      to=""
                      onClick={handleScrollToBottom}
                      className="btn btn-primary text-white hover_orange"
                    >
                      Get the App
                    </Link>
                  </div>
                  <div
                    className="col-md-6 orderimg "
                    data-aos="fade-right"
                    data-aos-duration="1000"
                    data-aos-delay="50"
                  >
                    <img
                      src={AboutUs}
                      alt=""
                      className="img-fluid aboutImgNew"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {!isRoleTherapist && therapistList.length > 0 && (
        <section id="explore" className="py-5 popukarsection">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h3 className="text-center">FEATURED THERAPISTS</h3>
                <h2
                  className="text-center"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-delay="50"
                >
                  <span>Connect with our top rated therapists</span>
                </h2>
              </div>
            </div>
          </div>
          <Tooltip id="my-tooltip-s" className="tooltip-custom-container" />

          <div
            className="carousel_box"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-delay="50"
          >
            <Carousel
              responsive={responsive}
              partialVisible={false}
              swipeable={true}
              draggable={true}
              itemclassName="carousel-item-padding-40-px"
              infinite={false} // Set to true if you want infinite scrolling
              keyBoardControl={true} // Enables keyboard arrow key navigation
              autoPlay={false} // Set to true if you want auto scroll
              removeArrowOnDeviceType={["tablet", "mobile"]} // Hides arrows on mobile
              customTransition="transform 300ms ease-in-out"
            >
              {therapistList.map((item, index) => {
                const itemId = item._id;
                const isCurrentCardSelected = selected_card == itemId;
                const current_item_in_fav_process =
                  isCurrentCardSelected && fav_loading;
                return (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      set_login_role();
                      trackEvent("view_therapist_cta", { event_type: "item_click", screen_name: "Home", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: user.details?.role, therapist_name: item.name });
                      navigate(`/therapistdetailspage/${itemId}`);
                    }}
                    key={index}
                    className="item_box"
                    style={{
                      userSelect: "none",
                      cursor: "pointer",
                    }}
                  >
                    <div className="item_body">
                      <div
                        style={{
                          pointerEvents: "none",
                        }}
                      >
                        <UserAvatar
                          profileImage={item.profile_img}
                          firstName={item.first_name || item.name}
                          lastName={item.last_name}
                          size="lg"
                          className="img-fluid"
                          alt={`${item.name} profile`}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h2 className="text-truncate">{item.name}</h2>
                        <div className="star">
                          <StarRatings
                            rating={parseFloat(Number(item.ratings).toFixed(1))}
                            starRatedColor="#FF674F"
                            numberOfStars={5}
                            name="rating"
                            starDimension="15px"
                            starSpacing={1}
                          />
                        </div>
                      </div>
                      <p
                        data-tooltip-id="my-tooltip-s"
                        data-tooltip-content={item.speciality}
                        className="truncated-text tooltip-container"
                      >
                        {item.speciality}
                      </p>
                      <p
                        data-tooltip-id="my-tooltip-s"
                        data-tooltip-content={item.bio}
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 2,
                          textOverflow: "ellipsis",
                          position: "relative",
                        }}
                      >
                        {item.bio}
                      </p>
                      <div className="carbtnFlex fav_container">
                        <Link
                          onClick={(e) => {
                            e.stopPropagation();
                            trackButtonClick("view_therapist_cta", { button_name: "Book therapist", screen_name: "Home", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: user.details?.role, therapist_name: item.name });
                            set_login_role();
                          }}
                          to={
                            isRoleTherapist
                              ? `/login`
                              : `/therapistdetailspage/${itemId}`
                          }
                          className="btn btn-primary"
                        >
                          Book therapist
                        </Link>

                        <div
                          className="fav_btn cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (fav_loading) return;
                            if (isRolePatient) {
                              add_to_favorite_fun(itemId, item.isFavorite);
                            } else {
                              set_login_role();
                              navigate("/login");
                            }
                          }}
                        >
                          {current_item_in_fav_process ? (
                            <FavLoader />
                          ) : item.isFavorite ? (
                            <FaHeart style={{ color: "#ff674f" }} />
                          ) : (
                            <FaRegHeart />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </section>
      )}

      <section className="pt-2 pb-5 pt-md-5 pb-md-5 therapy">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-2 order-lg-0 order-sm-0 order-xl-0 order-md-0">
              <div className="therapy_img d-none d-lg-block d-md-block">
                <img src={Therapy} alt="" className="img-fluid aboutImgNew" />
              </div>
              <img
                src={TherapyNew}
                alt=""
                className="img-fluid d-block d-sm-none d-lg-none"
              />
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-delay="150"
            >
              <h3>MENTAL HEALTH THERAPY</h3>
              <h2 className="mb-0">
                <span>Healing starts</span> here
              </h2>
              <p className="healingPara">
                Whatever you're facing, you don’t have to do it alone. Connect
                with a therapist who gets you. 
              </p>
              <ul>
                <li>
                  <img src={Hicon1} alt="" />
                  <span>General Mental Health</span>
                </li>
                <li>
                  <img src={icon6} alt="" />
                  <span>Grief</span>
                </li>
                <li>
                  <img src={icon2} alt="" />
                  <span>Stress, Anxiety, Depression</span>
                </li>
                <li>
                  <img src={icon7} alt="" />
                  <span>Rehabilitation</span>
                </li>
                <li>
                  <img src={icon3} alt="" />
                  <span>Marriage, Couples and Family</span>
                </li>
                <li>
                  <img src={icon8} alt="" />
                  <span>Sex</span>
                </li>
                <li>
                  <img src={icon4} alt="" />
                  <span>Substance Abuse</span>
                </li>
                <li>
                  <img src={icon9} alt="" />
                  <span>Eating Disorder</span>
                </li>
                <li>
                  <img src={icon5} alt="" />
                  <span>PTSD and Trauma</span>
                </li>
                <li>
                  <img src={icon10} alt="" />
                  <span>LGBTQ+</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section
        className="howitwork howitworkNew"
        style={{ backgroundImage: `url(${Gradient2IMG})` }}
      >
        <Tab.Container defaultActiveKey="first">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="mt-0">How it works</h2>
                <div className="navBox mb-4">
                  <Nav>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="first"
                        onClick={() => {
                          setSelectetTile("first");
                        }}
                      >
                        Wanna talk?
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="second"
                        onClick={() => {
                          setSelectetTile("second");
                        }}
                      >
                        Wanna listen?
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <h4>Welcome to your safe space</h4>
                    <p className="para">
                      Your mental well-being is our top priority. Find balance
                      and growth through meaningful connections, one session at
                      a time.
                    </p>
                    <div className="workImg">
                      <img src={Work1} alt="" className="img-fluid" />
                    </div>
                    <div className="row px-3">
                      <div className="col-lg-4">
                        <div className="contantBox">
                          <img src={Wicon1} alt="" className="img-fluid" />
                          <h5>Choose your therapist</h5>
                          <p>
                            Browse therapist profiles, including bios, genders,
                            languages spoken, pricing, and ratings, to find
                            someone you can truly connect with. Unlike other
                            platforms that assign a therapist, you have the
                            freedom to choose.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="contantBox">
                          <img src={Wicon2} alt="" className="img-fluid" />
                          <h5>Rebook or switch anytime</h5>
                          <p>
                            If you find a therapist who resonates with you,
                            rebooking is easy. Alternatively, you have the
                            flexibility to choose a different therapist whenever
                            you need.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="contantBox">
                          <img src={Wicon3} alt="" className="img-fluid" />
                          <h5>No commitment</h5>
                          <p>
                            Unlike other platforms, we don't require costly
                            subscriptions, allowing you to access the support
                            you need without financial burden.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <h4>Your practice, your way</h4>
                    <p className="para">
                      We’re dedicated to supporting your practice and helping
                      you connect with people who need your expertise. Build
                      meaningful relationships, foster growth, and make a
                      lasting impact—one session at a time. Your well-being and
                      success are just as important to us as your clients'.
                    </p>
                    <div className="workImg">
                      <img src={Work2} alt="" className="img-fluid" />
                    </div>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="contantBox">
                          <img src={Wicon4} alt="" className="img-fluid" />
                          <h5>Set your own rates</h5>
                          <p>
                            You have the freedom to set your rates, starting at
                            $39 for a 30-minute session or $59 for a 1-hour
                            session. This flexibility lets you align your
                            pricing with your expertise and the value you
                            provide, while remaining mindful of the market rates
                            for mental health services.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="contantBox">
                          <img src={Wicon5} alt="" className="img-fluid" />
                          <h5>Fast and easy setup</h5>
                          <p>
                            Creating a profile and starting to earn through
                            eCareTherapy is a seamless process that takes just a
                            few minutes. Once your profile is live, you can
                            start accepting bookings and providing your services
                            to clients.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="contantBox">
                          <img src={Wicon6} alt="" className="img-fluid" />
                          <h5>Immediate payments</h5>
                          <p>
                            We believe in fair compensation for our therapists,
                            which is why you receive 80% of each session fee
                            directly. This higher percentage reflects our
                            commitment to valuing your expertise and ensuring
                            you’re rewarded fairly for your work.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
                <div className="howBtnsBottom">
                  <Button
                    variant="default"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(ios_app_link);
                    }}
                  >
                    For iOS <img src={AppleIcon} alt="" />
                  </Button>
                  <Button
                    variant="default"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(android_app_link);
                    }}
                  >
                    For Android <img src={PlayStoreIcon} alt="" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Tab.Container>
      </section>

      <section className="step_box bg-white">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3>STEPS</h3>
              <h2>
                <span>Starting is simple</span>
              </h2>
            </div>
          </div>
          <Tab.Container
            activeKey={activeTab}
            onSelect={(k) => {
              setActiveTab(k);
            }}
          >
            <Row>
              {/* Vertical Tabs Navigation */}
              <Col md={6} className="mb-4 mb-sm-0">
                <Nav variant="pills" className="flex-column">
                  {steps.map((step, index) => (
                    <Nav.Item key={index}>
                      <Nav.Link
                        eventKey={step}
                        onMouseEnter={() => handleMouseEnter(step)}
                        onMouseLeave={handleMouseLeave}
                      >
                        {step === "step1" &&
                          "Download the app or visit the website"}
                        {step === "step2" && "Browse and filter therapists"}
                        {step === "step3" && "Choose and book"}
                        {step === "step4" && "Secure payment"}
                        {step === "step5" && "Get ready for your session"}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>

              {/* Content for each Tab */}
              <Col md={6}>
                <Tab.Content activeKey={activeTab}>
                  <Tab.Pane eventKey="step1">
                    <h5>Download the app or visit the website</h5>
                    <p>
                      Create a profile in minutes—for free! It’s quick and easy
                      to get started.
                    </p>
                    <img src={StepIMG1} alt="Step 1" className="img-fluid" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="step2">
                    <h5>Browse and filter therapists</h5>
                    <p>
                      Explore therapists based on your preferences. Read
                      reviews, specialties, and bios to find the right fit for
                      you.
                    </p>
                    <img src={StepIMG2} alt="Step 2" className="img-fluid" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="step3">
                    <h5>Choose and book</h5>
                    <p>
                      Select your therapist and book a session at your
                      convenience. See availability and schedule directly
                      through the app.
                    </p>
                    <img src={StepIMG3} alt="Step 3" className="img-fluid" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="step4">
                    <h5>Secure payment</h5>
                    <p>
                      Confirm your session with easy, secure payment. No
                      membership, no commitment—just pay for the sessions you
                      book, starting at $39 for 30 minutes.
                    </p>
                    <img src={StepIMG4} alt="Step 4" className="img-fluid" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="step5">
                    <h5>Get ready for your session</h5>
                    <p>
                      Choose the session format that works best for you—video,
                      audio, or chat. Find a comfortable space, log in at your
                      scheduled time, and connect with your therapist in a
                      secure, confidential environment.
                    </p>
                    <img src={StepIMG5} alt="Step 5" className="img-fluid" />
                  </Tab.Pane>
                  <ProgressBar now={progress} />
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </section>

      <section id="contactus" className="py-5 contactus">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4">
              <h3>CONTACT</h3>
              <h2>
                <span>Questions?</span> <br /> Reach out. We’re <br /> happy to
                help.
              </h2>
              <img
                src={ContactIMG}
                alt=""
                className="img-fluid d-none d-md-block"
              />
            </div>
            <div className="col-md-8">
              <Contact />
            </div>
          </div>
        </div>
        <div className="mobileContact d-block d-sm-none d-lg-none d-xl-none d-md-none">
          <img src={ContactIMG} alt="" className="img-fluid " />
        </div>
      </section>
    </>
  );
};

export default Home;
